export function safeNumber(input: any): number {
 return Number.isNaN(Number(input)) ? 0 : Number(input);
}
